import { Code, Stack, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import useUpdateAutomation from '@/hooks/api/automations/useUpdateAutomation.ts';
import StyledModal from '@/components/StyledModal/StyledModal.tsx';
import ModalConfirmationButtons from '@/components/StyledModal/ModalConfirmationButtons.tsx';
import StyledTextInput from '@/components/StyledInputFields/StyledTextInput.tsx';
import { Automation } from '@/types/automations.ts';
import { AUTOMATION_NAME_MAX_LENGTH } from '@/utils/constants.ts';

type EditAutomationNameModalProps = {
  automation: Automation;
  onClose: () => void;
};

const EditAutomationNameModal = ({ automation, onClose }: EditAutomationNameModalProps) => {
  const [name, setName] = useState(automation.name);
  const { mutate: editAutomationName, isSuccess } = useUpdateAutomation();

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  return (
    <StyledModal opened={true} onClose={onClose} title="Rename Automation" centered>
      <Stack gap="sm">
        <Text size="sm">
          Rename <Code>{automation.name}</Code> to:
        </Text>
        <StyledTextInput
          radius="md"
          placeholder="New name"
          size="sm"
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus={true}
          data-autofocus
          maxLength={AUTOMATION_NAME_MAX_LENGTH}
        />
      </Stack>
      <ModalConfirmationButtons
        onClose={onClose}
        onConfirm={() => editAutomationName({ id: automation.id, name: name })}
        confirmText={'Save'}
      />
    </StyledModal>
  );
};

export default EditAutomationNameModal;
